import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { getCleanHTML } from 'shared/lib/getCleanHTML'

import s from './styles.module.scss'

interface PolicyPopupProps {
  titleKey: string
  description: string
}

export const PolicyPopup = ({ titleKey, description }: PolicyPopupProps) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <h3 className={clsx('bold-20', s.title)}>{t(titleKey)}</h3>
      <p
        className={clsx('medium-14', s.text)}
        dangerouslySetInnerHTML={{
          __html: getCleanHTML(description),
        }}
      />
    </div>
  )
}
